<template>
  <router-view />
</template>

<script>
import '@popperjs/core'
import UserResource from './api/userResource'
import axios from 'axios'

const userResource = new UserResource()

export default {
  name: 'app',

   created(){
    if (this.getCookie('personID') !== '' && this.getCookie('password') !== '') {
      localStorage.removeItem('token');

      this.loginWithToken();
    }

 
   },


  mounted () { 


    this.setLocale()

    axios.interceptors.response.use(undefined, err => new Promise(() => {
      if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
        this.$store.dispatch('auth/setUserData', { user: null, token: null })
      }

      throw err
    }))

    if (localStorage.getItem('token')) {
      this.checkLogin()
    }

    document.addEventListener('keydown', (e) => {
      if (e.ctrlKey && e.keyCode === 76) {
        e.preventDefault()
        document.getElementById('search').focus()
      }
    })




  
  },

  methods: {


    loginWithToken() {

      userResource.loginWithHash(this.getCookie('personID'),this.getCookie('password')) 
      .then(response => {


        localStorage.setItem('token',response.data.data.token)
        this.deleteCookie('personID');
        this.deleteCookie('password');
        this.$store.dispatch('auth/setUserData', response.data.data.user)

        window.location.href = '/';
      })
      .catch(() => {
        this.$router.push('/');
      });
      },




    getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  
    deleteCookie( name, path, domain ) {
    if(this.getCookie(name)  !== '') {
      document.cookie = name + "=" +
        ((path) ? ";path="+path:"")+
        ((domain)?";domain="+domain:"") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
  },


 




    setLocale () {
      const locale = localStorage.getItem('locale')
      if (locale) {
        this.$store.dispatch('localization/setLocale', locale)
      }
    },

    checkLogin () {
      userResource.user()
        .then(response => {

          
          axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('token')}`
          this.$store.dispatch('auth/setUserData', {

             
            user: response.data.data,
            token: localStorage.getItem('token')
          }) 
         }).catch(() => {
          localStorage.removeItem('token')
          this.$router.push('/login')
        })
    }
  }
}
</script>
<style lang="scss" src="./assets/scss/custom.scss"></style>
